import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.drive');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-drive',
template: templateSource || '',
    styles: [`

/* file: /Users/ijaemun/Documents/Codex/2026-09-30/task/migration-prep/mac-candidate-build/src/app/page.drive/view.scss */
@charset "UTF-8";
:host {
  display: block;
  height: 100%;
}

.drive-shell {
  position: relative;
}

.drive-main-content {
  min-width: 0;
}

.drive-preview-panel {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  width: clamp(320px, 42vw, 620px);
  min-width: 0;
  background: #ffffff;
  border: 0.5px solid #cbd5e1;
  border-right: 0;
  box-shadow: -8px 0 24px rgba(15, 23, 42, 0.14);
}

.drive-shell-retro .drive-preview-panel {
  border-color: #999999;
  border-right: 0;
  border-left-width: 0.5px;
  box-shadow: -6px 0 18px rgba(0, 0, 0, 0.18);
}

.drive-preview-panel iframe {
  border-top: 0.5px solid #e2e8f0 !important;
}

.drive-shell-retro .drive-preview-panel iframe {
  border-top-color: #cccccc !important;
}

.drive-metadata-status-badge {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 3px 9px;
  color: #b45309;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 999px;
}

.drive-metadata-status-badge.is-confirmed {
  color: #047857;
  background: #ecfdf5;
  border-color: #a7f3d0;
}

.drive-metadata-review {
  box-sizing: border-box;
  width: min(100%, 1120px);
  min-height: 100%;
  margin: 0 auto;
  padding: 24px 24px 28px;
  color: #0f172a;
}

.drive-metadata-heading,
.drive-metadata-title-row,
.drive-metadata-bulk,
.drive-metadata-bulk-actions,
.drive-metadata-role-control,
.drive-metadata-confirm-bar,
.drive-metadata-confirm-actions,
.drive-metadata-review-status,
.drive-metadata-help {
  display: flex;
  align-items: center;
}

.drive-metadata-heading {
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 16px;
}

.drive-metadata-heading-copy,
.drive-metadata-bulk-copy,
.drive-metadata-confirm-copy {
  min-width: 0;
}

.drive-metadata-title-row {
  flex-wrap: wrap;
  gap: 9px;
}

.drive-metadata-title {
  margin: 0;
  color: #0f172a;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.35;
}

.drive-metadata-file-count {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  padding: 2px 8px;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 999px;
}

.drive-metadata-subtitle {
  margin: 5px 0 0;
  color: #64748b;
  font-size: 12px;
  line-height: 1.55;
}

.drive-metadata-review-status {
  flex: 0 0 auto;
  gap: 7px;
  min-height: 32px;
  padding: 5px 10px;
  color: #92400e;
  font-size: 11px;
  font-weight: 800;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 9px;
}

.drive-metadata-review-status.is-confirmed {
  color: #047857;
  background: #ecfdf5;
  border-color: #a7f3d0;
}

.drive-metadata-review-status.has-changes {
  color: #c2410c;
  background: #fff7ed;
  border-color: #fed7aa;
}

.drive-metadata-review-status-dot {
  width: 7px;
  height: 7px;
  background: currentColor;
  border-radius: 50%;
}

.drive-metadata-help {
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 12px;
  padding: 12px 14px;
  color: #155e75;
  background: #ecfeff;
  border: 1px solid #cffafe;
  border-radius: 10px;
}

.drive-metadata-help-icon {
  display: inline-flex;
  flex: 0 0 20px;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-top: 1px;
  font-size: 11px;
  font-weight: 800;
  font-style: normal;
  border: 1px solid #67e8f9;
  border-radius: 50%;
}

.drive-metadata-help-title {
  font-size: 11px;
  font-weight: 800;
  line-height: 1.4;
}

.drive-metadata-help-text {
  margin-top: 2px;
  color: #0e7490;
  font-size: 11px;
  line-height: 1.5;
}

.drive-metadata-bulk {
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 14px;
  padding: 13px 14px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.drive-metadata-bulk-copy {
  display: flex;
  flex-direction: column;
}

.drive-metadata-bulk-title {
  color: #334155;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.4;
}

.drive-metadata-bulk-description {
  margin-top: 2px;
  color: #94a3b8;
  font-size: 11px;
  line-height: 1.45;
}

.drive-metadata-bulk-actions,
.drive-metadata-role-control,
.drive-metadata-confirm-actions {
  flex: 0 0 auto;
  gap: 8px;
}

.drive-metadata-select {
  box-sizing: border-box;
  min-width: 168px;
  min-height: 36px;
  padding: 6px 30px 6px 10px;
  color: #1e293b;
  font-family: "SUIT", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 12px;
  font-weight: 650;
  line-height: 1.35;
  background: #ffffff;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  outline: none;
}

.drive-metadata-select:hover {
  border-color: #94a3b8;
}

.drive-metadata-select:focus-visible,
.drive-metadata-secondary-button:focus-visible,
.drive-metadata-tertiary-button:focus-visible,
.drive-metadata-confirm-button:focus-visible {
  outline: 2px solid #818cf8;
  outline-offset: 2px;
}

.drive-metadata-select:disabled,
.drive-metadata-review button:disabled {
  cursor: not-allowed;
  opacity: 0.58;
}

.drive-metadata-secondary-button,
.drive-metadata-tertiary-button,
.drive-metadata-confirm-button {
  box-sizing: border-box;
  min-height: 36px;
  padding: 7px 13px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 750;
  line-height: 1.3;
  border-radius: 8px;
  cursor: pointer;
}

.drive-metadata-secondary-button {
  color: #4f46e5;
  background: #eef2ff;
  border: 1px solid #c7d2fe;
}

.drive-metadata-secondary-button:hover:not(:disabled) {
  color: #4338ca;
  background: #e0e7ff;
}

.drive-metadata-table-wrap {
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
}

.drive-metadata-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.drive-metadata-table th {
  padding: 11px 16px;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.35;
  text-align: left;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.drive-metadata-table th.drive-metadata-role-heading {
  width: 230px;
}

.drive-metadata-table td {
  padding: 13px 16px;
  vertical-align: middle;
  border-bottom: 1px solid #f1f5f9;
}

.drive-metadata-table tr:last-child td {
  border-bottom: 0;
}

.drive-metadata-table tbody tr {
  transition: background-color 120ms ease;
}

.drive-metadata-table tbody tr:hover {
  background: #f8fafc;
}

.drive-metadata-table tbody tr.drive-metadata-row-dirty {
  background: #fff7ed;
}

.drive-metadata-file-name {
  overflow: hidden;
  color: #1e293b;
  font-size: 12px;
  font-weight: 750;
  line-height: 1.45;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.drive-metadata-file-description {
  display: -webkit-box;
  overflow: hidden;
  margin-top: 3px;
  color: #94a3b8;
  font-size: 11px;
  line-height: 1.45;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.drive-metadata-role-cell {
  width: 230px;
}

.drive-metadata-dirty-badge {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 2px 7px;
  color: #c2410c;
  font-size: 10px;
  font-weight: 800;
  background: #ffedd5;
  border: 1px solid #fed7aa;
  border-radius: 999px;
}

.drive-metadata-empty {
  padding: 56px 20px;
  color: #94a3b8;
  font-size: 12px;
  text-align: center;
  background: #ffffff;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
}

.drive-metadata-confirm-bar {
  position: sticky;
  bottom: 14px;
  z-index: 4;
  justify-content: space-between;
  gap: 20px;
  margin-top: 16px;
  padding: 13px 14px 13px 16px;
  background: rgba(255, 255, 255, 0.97);
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.13);
  backdrop-filter: blur(8px);
}

.drive-metadata-confirm-title {
  color: #1e293b;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.4;
}

.drive-metadata-confirm-description {
  margin-top: 2px;
  color: #64748b;
  font-size: 11px;
  line-height: 1.45;
}

.drive-metadata-tertiary-button {
  color: #475569;
  background: #ffffff;
  border: 1px solid #cbd5e1;
}

.drive-metadata-tertiary-button:hover:not(:disabled) {
  color: #1e293b;
  background: #f8fafc;
}

.drive-metadata-confirm-button {
  min-width: 150px;
  color: #ffffff;
  background: #4f46e5;
  border: 1px solid #4338ca;
}

.drive-metadata-confirm-button:hover:not(:disabled) {
  background: #4338ca;
}

.drive-shell-retro .drive-metadata-status-badge,
.drive-metadata-review-retro .drive-metadata-file-count,
.drive-metadata-review-retro .drive-metadata-review-status,
.drive-metadata-review-retro .drive-metadata-help,
.drive-metadata-review-retro .drive-metadata-bulk,
.drive-metadata-review-retro .drive-metadata-table-wrap,
.drive-metadata-review-retro .drive-metadata-empty,
.drive-metadata-review-retro .drive-metadata-confirm-bar,
.drive-metadata-review-retro .drive-metadata-select,
.drive-metadata-review-retro button,
.drive-metadata-review-retro .drive-metadata-dirty-badge {
  border-radius: 0;
}

.drive-metadata-review-retro {
  padding: 18px;
  color: #222222;
  font-family: "돋움", Dotum, sans-serif;
}

.drive-metadata-review-retro .drive-metadata-title {
  color: #003366;
  font-size: 16px;
}

.drive-metadata-review-retro .drive-metadata-subtitle,
.drive-metadata-review-retro .drive-metadata-confirm-description,
.drive-metadata-review-retro .drive-metadata-bulk-description,
.drive-metadata-review-retro .drive-metadata-file-description {
  color: #777777;
}

.drive-metadata-review-retro .drive-metadata-help {
  color: #005c66;
  background: #eefafa;
  border-color: #99cccc;
}

.drive-metadata-review-retro .drive-metadata-help-text {
  color: #006b78;
}

.drive-metadata-review-retro .drive-metadata-bulk,
.drive-metadata-review-retro .drive-metadata-table-wrap,
.drive-metadata-review-retro .drive-metadata-confirm-bar {
  border-color: #cccccc;
  box-shadow: none;
}

.drive-metadata-review-retro .drive-metadata-select {
  font-family: "돋움", Dotum, sans-serif;
  border-color: #aaaaaa;
}

.drive-metadata-review-retro .drive-metadata-table th {
  color: #444444;
  background: #e8e8e8;
  border-bottom-color: #cccccc;
}

.drive-metadata-review-retro .drive-metadata-table td {
  border-bottom-color: #eeeeee;
}

.drive-metadata-review-retro .drive-metadata-secondary-button,
.drive-metadata-review-retro .drive-metadata-confirm-button {
  color: #ffffff;
  background: #003366;
  border-color: #001a33;
}

.drive-metadata-review-retro .drive-metadata-confirm-bar {
  background: #f5f5f5;
  backdrop-filter: none;
}

@media (max-width: 860px) {
  .drive-preview-panel {
    left: 0;
    width: 100%;
  }
}
@media (max-width: 767px) {
  .drive-shell {
    min-width: 0;
    overflow: hidden;
  }
  .drive-shell .drive-header {
    align-items: stretch !important;
    flex-direction: column;
    gap: 8px;
    padding: 8px !important;
  }
  .drive-shell .drive-title-search {
    flex-wrap: wrap;
    gap: 6px !important;
    width: 100%;
  }
  .drive-shell .drive-search {
    flex: 1 1 180px;
    width: 100%;
    max-width: none !important;
    margin-left: 0 !important;
  }
  .drive-shell .drive-actions {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .drive-shell .drive-actions::-webkit-scrollbar {
    display: none;
  }
  .drive-shell .drive-actions button {
    flex: 0 0 auto;
    min-height: 30px;
    padding: 4px 8px !important;
    font-size: 11px !important;
    white-space: nowrap;
  }
  .drive-shell .drive-service-meta,
  .drive-shell .drive-breadcrumb,
  .drive-shell .drive-summary,
  .drive-shell .drive-new-folder {
    flex-wrap: wrap;
    gap: 5px !important;
    padding: 6px 8px !important;
  }
  .drive-shell .drive-breadcrumb > div:first-child {
    min-width: 0;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .drive-shell .drive-breadcrumb > div:first-child::-webkit-scrollbar {
    display: none;
  }
  .drive-shell .drive-breadcrumb button,
  .drive-shell .drive-new-folder button,
  .drive-shell .drive-new-folder span {
    white-space: nowrap;
  }
  .drive-shell .drive-new-folder input {
    flex: 1 1 160px;
    width: auto !important;
    min-width: 0;
  }
  .drive-main-content {
    overflow-x: hidden !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
  }
  .drive-table-wrap {
    margin: 10px !important;
    border-radius: 8px !important;
  }
  .drive-preview-panel {
    left: 0;
    width: 100% !important;
    max-width: none;
    box-shadow: none;
  }
  .drive-preview-panel > div:first-child {
    flex-wrap: wrap;
    padding: 8px !important;
  }
  .drive-shell-retro {
    min-width: 0;
    overflow: hidden;
  }
  .drive-shell-retro .drive-retro-header {
    align-items: stretch !important;
    flex-direction: column;
    gap: 6px;
    padding: 8px !important;
  }
  .drive-shell-retro .drive-retro-title-search {
    flex-wrap: wrap;
    gap: 6px !important;
    width: 100%;
  }
  .drive-shell-retro .drive-retro-search {
    flex: 1 1 180px;
    width: 100%;
    max-width: none !important;
    margin-left: 0 !important;
  }
  .drive-shell-retro .drive-retro-actions {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .drive-shell-retro .drive-retro-actions::-webkit-scrollbar {
    display: none;
  }
  .drive-shell-retro .drive-retro-actions button {
    flex: 0 0 auto;
    padding: 4px 8px !important;
    font-size: 11px !important;
    white-space: nowrap;
  }
  .drive-shell-retro .drive-retro-service-meta,
  .drive-shell-retro .drive-retro-breadcrumb,
  .drive-shell-retro .drive-retro-summary,
  .drive-shell-retro .drive-retro-new-folder {
    flex-wrap: wrap;
    gap: 5px !important;
    padding: 6px 8px !important;
  }
  .drive-shell-retro .drive-retro-breadcrumb > div:first-child {
    min-width: 0;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }
  .drive-shell-retro .drive-retro-breadcrumb > div:first-child::-webkit-scrollbar {
    display: none;
  }
  .drive-shell-retro .drive-retro-breadcrumb button,
  .drive-shell-retro .drive-retro-new-folder button,
  .drive-shell-retro .drive-retro-new-folder span {
    white-space: nowrap;
  }
  .drive-shell-retro .drive-retro-new-folder input {
    flex: 1 1 160px;
    width: auto !important;
    min-width: 0;
  }
  .drive-shell-retro .drive-main-content {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }
  .drive-shell-retro table {
    min-width: 720px;
  }
  .drive-shell-retro input,
  .drive-shell-retro select,
  .drive-shell-retro textarea,
  .drive-shell-retro button {
    max-width: 100%;
  }
  .drive-file-table,
  .drive-file-table tbody,
  .drive-file-table tr,
  .drive-file-table td,
  .drive-metadata-table,
  .drive-metadata-table tbody,
  .drive-metadata-table tr,
  .drive-metadata-table td {
    display: block;
    width: 100%;
    box-sizing: border-box;
  }
  .drive-file-table,
  .drive-metadata-table {
    min-width: 0 !important;
    table-layout: auto !important;
  }
  .drive-file-table thead,
  .drive-metadata-table thead {
    display: none;
  }
  .drive-file-table tr {
    position: relative;
    min-height: 68px;
    padding: 10px 10px 10px 42px;
    border-bottom: 1px solid #e5e7eb !important;
    background: #ffffff;
  }
  .drive-file-table tr:last-child {
    border-bottom: 0 !important;
  }
  .drive-file-table td {
    padding: 0 !important;
    border: 0 !important;
    text-align: left !important;
  }
  .drive-file-table td:first-child {
    position: absolute;
    top: 12px;
    left: 10px;
    width: 24px;
    text-align: center !important;
  }
  .drive-file-table td:nth-child(2) {
    min-width: 0;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.35;
  }
  .drive-file-table .truncate {
    overflow: visible !important;
    text-overflow: clip !important;
    white-space: normal !important;
    word-break: break-word;
  }
  .drive-file-table td:nth-child(2) div {
    min-width: 0;
  }
  .drive-file-table td:nth-child(2) div[style*="display: flex"] {
    flex-wrap: wrap;
  }
  .drive-file-table td:nth-child(2) [style*="white-space: nowrap"] {
    overflow: visible !important;
    text-overflow: clip !important;
    white-space: normal !important;
    word-break: break-word;
  }
  .drive-file-table td:not(:first-child):not(:nth-child(2)):not(:last-child) {
    display: inline-flex;
    align-items: center;
    width: auto;
    margin-top: 5px;
    margin-right: 8px;
    color: #64748b !important;
    font-size: 10px;
    line-height: 1.3;
    vertical-align: top;
  }
  .drive-file-table td:last-child {
    margin-top: 8px;
  }
  .drive-file-table td:last-child > div {
    justify-content: flex-start !important;
    flex-wrap: wrap;
    gap: 6px !important;
    white-space: normal !important;
  }
  .drive-file-table td:last-child button {
    min-height: 26px;
    padding: 2px 6px !important;
    line-height: 1.2;
  }
  .drive-file-table .drive-cell-kind {
    position: absolute;
    top: 12px;
    left: 10px;
    width: 24px !important;
    text-align: center !important;
  }
  .drive-file-table .drive-cell-name {
    display: block !important;
    min-width: 0;
    color: #0f172a !important;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.35;
  }
  .drive-file-table .drive-cell-name::before,
  .drive-file-table .drive-cell-size::before,
  .drive-file-table .drive-cell-role::before,
  .drive-file-table .drive-cell-updated::before {
    color: #94a3b8;
    font-size: 10px;
    font-weight: 700;
    line-height: 1.2;
  }
  .drive-file-table .drive-cell-name::before {
    content: "이름";
    display: block;
    margin-bottom: 2px;
  }
  .drive-file-table .drive-cell-name .truncate,
  .drive-file-table .drive-cell-name [style*="white-space: nowrap"] {
    display: inline !important;
    overflow: visible !important;
    text-overflow: clip !important;
    white-space: normal !important;
    word-break: break-word;
  }
  .drive-file-table .drive-cell-size,
  .drive-file-table .drive-cell-role,
  .drive-file-table .drive-cell-updated {
    display: inline-flex !important;
    align-items: center;
    width: auto !important;
    margin-top: 7px;
    margin-right: 9px;
    color: #475569 !important;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.3;
  }
  .drive-file-table .drive-cell-size::before {
    content: "크기";
    margin-right: 4px;
  }
  .drive-file-table .drive-cell-role::before {
    content: "역할";
    margin-right: 4px;
  }
  .drive-file-table .drive-cell-updated::before {
    content: "수정";
    margin-right: 4px;
  }
  .drive-file-table .drive-cell-actions {
    display: block !important;
    width: 100% !important;
    margin-top: 9px;
  }
  .drive-metadata-review {
    width: 100%;
    padding: 16px 10px 22px;
  }
  .drive-metadata-heading,
  .drive-metadata-bulk,
  .drive-metadata-confirm-bar {
    align-items: stretch;
    flex-direction: column;
  }
  .drive-metadata-heading {
    gap: 10px;
    margin-bottom: 12px;
  }
  .drive-metadata-title {
    font-size: 17px;
  }
  .drive-metadata-review-status {
    align-self: flex-start;
  }
  .drive-metadata-help,
  .drive-metadata-bulk {
    padding: 12px;
  }
  .drive-metadata-bulk {
    gap: 10px;
  }
  .drive-metadata-bulk-actions,
  .drive-metadata-confirm-actions {
    width: 100%;
  }
  .drive-metadata-bulk-select,
  .drive-metadata-bulk-actions .drive-metadata-secondary-button {
    flex: 1 1 0;
    min-width: 0;
  }
  .drive-metadata-table tr {
    padding: 13px 12px;
    border-bottom: 1px solid #e5e7eb !important;
    background: #ffffff;
  }
  .drive-metadata-table tr:last-child {
    border-bottom: 0 !important;
  }
  .drive-metadata-table td {
    padding: 0 !important;
    border: 0 !important;
    text-align: left !important;
    overflow-wrap: anywhere;
  }
  .drive-metadata-file-name {
    overflow: visible;
    font-size: 12px;
    text-overflow: clip;
    white-space: normal;
    word-break: break-word;
  }
  .drive-metadata-role-cell {
    width: 100% !important;
    margin-top: 12px;
    padding-top: 11px !important;
    border-top: 1px solid #f1f5f9 !important;
  }
  .drive-metadata-role-cell::before {
    display: block;
    margin-bottom: 6px;
    color: #94a3b8;
    font-size: 10px;
    font-weight: 700;
    content: "최종 역할";
  }
  .drive-metadata-role-control {
    width: 100%;
  }
  .drive-metadata-role-control .drive-metadata-select {
    flex: 1 1 auto;
    min-width: 0;
    min-height: 42px;
  }
  .drive-metadata-confirm-bar {
    bottom: 8px;
    gap: 11px;
    padding: 12px;
  }
  .drive-metadata-confirm-actions button {
    flex: 1 1 0;
    min-width: 0;
    min-height: 44px;
  }
}
.legacy-roomy-controls .roomy-button,
.legacy-roomy-controls td > button {
  box-sizing: border-box;
  min-height: 22px;
  padding: 3px 9px !important;
  line-height: 1.35;
}
.legacy-roomy-controls .roomy-badge,
.legacy-roomy-controls td > span {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  padding: 2px 7px !important;
  line-height: 1.35;
}

[draggable=true] {
  cursor: grab;
}

[draggable=true]:active {
  cursor: grabbing;
}

.drive-dragging {
  opacity: 0.45;
}

.drive-drop-target {
  outline: 2px solid #6366f1;
  outline-offset: -2px;
  background: #eef2ff !important;
}`],
})
export class PageDriveComponent implements OnInit {
    public folders: any[] = [];
    public files: any[] = [];
    public currentFolder: string = '';
    public breadcrumb: any[] = [];
    public fileCount: number = 0;
    public page: number = 1;
    public dump: number = 50;
    public searchText: string = '';
    public driveViewScope: string = 'personal';
    public driveView: any = null;

    // UI state
    public newFolderName: string = '';
    public showNewFolder: boolean = false;
    public creatingFolder: boolean = false;
    public editingId: string = '';
    public editingName: string = '';
    public selectedItems: Set<string> = new Set();
    public selectedItem: string = '';
    public selectMode: boolean = false;
    public creatingInspection: boolean = false;
    public creatingDataset: boolean = false;
    public draggingItem: any = null;
    public dragOverFolderId: string = '';
    public movingItem: boolean = false;
    private driveDragMime: string = 'application/x-wiz-drive-item';
    public previewFile: any = null;
    public previewUrl: string = '';
    public showInspectionSelector: boolean = false;
    public inspectionCandidates: any[] = [];
    public inspectionSelection: any = {};
    public inspectionCandidatePolicy: any = null;
    public driveContext: any = null;
    public shareDepartments: string[] = [];
    public showShareModal: boolean = false;
    public shareFile: any = null;
    public shareTargetDepartment: string = '';
    public shareNote: string = '';
    public shareSubmitting: boolean = false;
    public showShareRequestsModal: boolean = false;
    public shareRequestsLoading: boolean = false;
    public reviewShareRequests: any[] = [];
    public mineShareRequests: any[] = [];
    public shareReviewSavingId: string = '';

    // 업로드 진행 상태
    public uploading: boolean = false;
    public uploadProgress: string = '';
    public uploadPercent: number = 0;

    // 메타데이터
    public metadata: any = null;
    public generatingMeta: boolean = false;
    public showMetaPanel: boolean = false;
    public metaProgress: string = '';
    public metaPercent: number = 0;
    public bulkMetadataRole: string = 'report';
    public metadataDraftRoles: { [fileId: string]: string } = {};
    public metadataSavedRoles: { [fileId: string]: string } = {};
    public metadataDraftFolderId: string = '';
    public confirmingMetadata: boolean = false;
    public metadataReviewMessage: string = '';
    public readonly metadataRoleOptions: any[] = [
        { role: 'report', label: '보고서' },
        { role: 'reference', label: '전차보고서 DB' },
        { role: '부록', label: '부록' },
        { role: 'contract', label: '계약서' },
        { role: 'kickoff', label: '착수계' },
        { role: 'ledger', label: '관리대장' },
        { role: 'other', label: '기타' },
    ];

    // 용역명
    public serviceName: string = '';
    public editingServiceName: boolean = false;
    public savingServiceName: boolean = false;

    // 테마
    public theme: string = 'modern';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.theme = localStorage.getItem('ui-theme') || 'modern';
        await this.load();
    }

    public async load() {
        const preserveDrafts = this.metadataPendingCount > 0
            && this.metadataDraftFolderId === this.currentFolder;
        const previousDraftRoles = { ...this.metadataDraftRoles };
        const previousSavedRoles = { ...this.metadataSavedRoles };
        const previousReviewMessage = this.metadataReviewMessage;
        let res: any = await wiz.call("list", {
            folder_id: this.currentFolder,
            page: this.page,
            dump: this.dump,
            text: this.searchText,
            scope: this.driveViewScope,
        });
        if (res.code === 200) {
            this.folders = res.data.folders || [];
            this.files = res.data.files || [];
            this.fileCount = res.data.file_count || 0;
            this.breadcrumb = res.data.breadcrumb || [];
            this.currentFolder = res.data.current_folder || '';
            this.metadata = res.data.metadata || null;
            this.serviceName = this.metadata?.service_name || '';
            this.driveContext = res.data.drive_context || null;
            this.driveView = res.data.drive_view || null;
            this.driveViewScope = this.driveView?.scope === 'shared' ? 'shared' : 'personal';
            const metadataIds = Array.isArray(this.metadata?.files)
                ? this.metadata.files.filter((file: any) => !!file?.id).map((file: any) => String(file.id)).sort()
                : [];
            const draftIds = Object.keys(previousDraftRoles).sort();
            const canPreserveDrafts = preserveDrafts
                && this.metadataDraftFolderId === this.currentFolder
                && metadataIds.length === draftIds.length
                && metadataIds.every((fileId: string, index: number) => fileId === draftIds[index]);
            if (canPreserveDrafts) {
                this.metadataDraftRoles = previousDraftRoles;
                this.metadataSavedRoles = previousSavedRoles;
                this.metadataReviewMessage = previousReviewMessage;
            } else {
                this._resetMetadataDraftRoles();
            }
        }
        this.selectedItems.clear();
        this.selectedItem = '';
        await this.service.render();
    }

    public get isShareReviewer(): boolean {
        const role = String(this.service?.auth?.session?.role || '').trim().toLowerCase();
        return role === 'admin' || role === 'department_admin';
    }

    public async loadShareDepartments() {
        try {
            const res: any = await wiz.call('share_departments');
            if (res.code === 200) {
                this.shareDepartments = Array.isArray(res.data?.departments) ? res.data.departments : [];
                if (!this.shareTargetDepartment && this.shareDepartments.length > 0) {
                    this.shareTargetDepartment = this.shareDepartments[0];
                }
            }
        } catch (e) {
            this.shareDepartments = [];
        }
    }

    public async openShareModal(file: any) {
        if (!file?.id || this.isMissingFile(file)) return;
        this.shareFile = file;
        this.shareTargetDepartment = '';
        this.shareNote = '';
        this.showShareModal = true;
        await this.loadShareDepartments();
        await this.service.render();
    }

    public async closeShareModal() {
        if (this.shareSubmitting) return;
        this.showShareModal = false;
        this.shareFile = null;
        this.shareTargetDepartment = '';
        this.shareNote = '';
        await this.service.render();
    }

    public async submitShareRequest() {
        if (this.shareSubmitting || !this.shareFile?.id || !this.shareTargetDepartment) return;
        this.shareSubmitting = true;
        await this.service.render();
        try {
            const res: any = await wiz.call('request_file_share', {
                file_id: this.shareFile.id,
                target_department: this.shareTargetDepartment,
                note: this.shareNote,
            });
            if (res.code === 200) {
                this.showShareModal = false;
                await this.service.modal.show({
                    title: '공유 요청 완료',
                    message: '관리자 승인 대기 상태로 공유 요청을 등록했습니다.',
                    action: '확인',
                    cancel: false,
                    status: 'success',
                });
            } else {
                await this._showDriveError('공유 요청 실패', this.getResponseMessage(res, '공유 요청을 등록하지 못했습니다.'));
            }
        } catch (e) {
            await this._showDriveError('공유 요청 실패', this.getErrorMessage(e, '공유 요청을 등록하지 못했습니다.'));
        }
        this.shareSubmitting = false;
        await this.service.render();
    }

    public async loadShareRequests() {
        this.shareRequestsLoading = true;
        await this.service.render();
        try {
            const res: any = await wiz.call('share_requests');
            if (res.code === 200) {
                this.reviewShareRequests = Array.isArray(res.data?.reviewable) ? res.data.reviewable : [];
                this.mineShareRequests = Array.isArray(res.data?.mine) ? res.data.mine : [];
            } else {
                await this._showDriveError('공유 현황 로딩 실패', this.getResponseMessage(res, '공유 요청 현황을 불러오지 못했습니다.'));
            }
        } catch (e) {
            await this._showDriveError('공유 현황 로딩 실패', this.getErrorMessage(e, '공유 요청 현황을 불러오지 못했습니다.'));
        }
        this.shareRequestsLoading = false;
        await this.service.render();
    }

    public async openShareRequestsModal() {
        this.showShareRequestsModal = true;
        await this.loadShareRequests();
    }

    public async closeShareRequestsModal() {
        if (this.shareReviewSavingId) return;
        this.showShareRequestsModal = false;
        await this.service.render();
    }

    public async approveShareRequest(request: any) {
        const requestId = String(request?.id || '');
        if (!requestId || this.shareReviewSavingId) return;
        const ok = await this.service.modal.show({
            title: '공유 승인',
            message: `${request.source_file_name || '선택한 파일'}을 ${request.target_department || '대상 부서'}에 공유하시겠습니까?`,
            action: '승인',
            actionBtn: 'success',
        });
        if (!ok) return;
        this.shareReviewSavingId = requestId;
        await this.service.render();
        try {
            const res: any = await wiz.call('approve_share_request', { request_id: requestId });
            if (res.code === 200) {
                await this.loadShareRequests();
            } else {
                await this._showDriveError('공유 승인 실패', this.getResponseMessage(res, '공유 요청을 승인하지 못했습니다.'));
            }
        } catch (e) {
            await this._showDriveError('공유 승인 실패', this.getErrorMessage(e, '공유 요청을 승인하지 못했습니다.'));
        }
        this.shareReviewSavingId = '';
        await this.service.render();
    }

    public async rejectShareRequest(request: any) {
        const requestId = String(request?.id || '');
        if (!requestId || this.shareReviewSavingId) return;
        const ok = await this.service.modal.show({
            title: '공유 반려',
            message: `${request.source_file_name || '선택한 파일'} 공유 요청을 반려하시겠습니까?`,
            action: '반려',
            actionBtn: 'error',
        });
        if (!ok) return;
        this.shareReviewSavingId = requestId;
        await this.service.render();
        try {
            const res: any = await wiz.call('reject_share_request', { request_id: requestId });
            if (res.code === 200) {
                await this.loadShareRequests();
            } else {
                await this._showDriveError('공유 반려 실패', this.getResponseMessage(res, '공유 요청을 반려하지 못했습니다.'));
            }
        } catch (e) {
            await this._showDriveError('공유 반려 실패', this.getErrorMessage(e, '공유 요청을 반려하지 못했습니다.'));
        }
        this.shareReviewSavingId = '';
        await this.service.render();
    }

    public shareDateLabel(value: any): string {
        return String(value || '').replace('T', ' ').slice(0, 19) || '-';
    }

    public shareStatusClass(request: any): string {
        const status = String(request?.status || '').trim().toLowerCase();
        if (status === 'approved') return 'bg-emerald-50 text-emerald-700 border-emerald-100';
        if (status === 'rejected') return 'bg-red-50 text-red-600 border-red-100';
        return 'bg-amber-50 text-amber-700 border-amber-100';
    }

    public async openFolder(folderId: string) {
        if (!await this._allowMetadataDraftDiscard('다른 폴더로 이동', '변경 취소하고 이동')) return;
        this.closePreview();
        this._resetInspectionSelector();
        this.currentFolder = folderId;
        this.page = 1;
        this.searchText = '';
        this.showMetaPanel = false;
        this.editingServiceName = false;
        await this.load();
    }

    public async openFolderMetadata(folder: any) {
        const folderId = String(folder?.id || '');
        if (!folderId || this.metadataBusy) return;

        await this.openFolder(folderId);
        if (this.currentFolder !== folderId) return;

        if (this.metadata) {
            this._resetMetadataDraftRoles();
            this.showMetaPanel = true;
            await this.service.render();
            return;
        }

        if (this.files.length > 0) {
            await this.generateMetadata(true);
            return;
        }

        await this.service.modal.show({
            title: '분류할 파일 없음',
            message: '이 폴더에는 AI 분류할 파일이 없습니다.',
            action: '확인',
            cancel: false,
            status: 'warning',
        });
    }

    public async goRoot() {
        if (!await this._allowMetadataDraftDiscard('Drive 홈으로 이동', '변경 취소하고 이동')) return;
        this.closePreview();
        this._resetInspectionSelector();
        this.currentFolder = '';
        this.page = 1;
        this.searchText = '';
        this.metadata = null;
        this.showMetaPanel = false;
        this.serviceName = '';
        this.editingServiceName = false;
        await this.load();
    }

    public async navigateBreadcrumb(folderId: string) {
        if (!await this._allowMetadataDraftDiscard('다른 폴더로 이동', '변경 취소하고 이동')) return;
        this.closePreview();
        this._resetInspectionSelector();
        this.currentFolder = folderId;
        this.page = 1;
        this.showMetaPanel = false;
        this.editingServiceName = false;
        await this.load();
    }

    // ── 선택 모드 ──

    public async toggleSelectMode() {
        this.selectMode = !this.selectMode;
        if (!this.selectMode) {
            this.selectedItems.clear();
        }
        await this.service.render();
    }

    // ── 용역명 ──

    public async startEditServiceName() {
        if (this.metadataBusy) return;
        this.editingServiceName = true;
        await this.service.render();
    }

    public async saveServiceName() {
        if (this.savingServiceName || this.confirmingMetadata || this.generatingMeta || this.uploading) return;
        const folderId = this.currentFolder;
        this.savingServiceName = true;
        await this.service.render();
        try {
            const res: any = await wiz.call("save_service_name", {
                folder_id: folderId,
                service_name: this.serviceName,
                expected_updated: this.metadata?.updated || '',
            });
            if (res?.code !== 200 || !res.data?.metadata) {
                throw new Error(this.getResponseMessage(res, '용역명을 저장하지 못했습니다.'));
            }
            if (folderId !== this.currentFolder) return;
            this.metadata = res.data.metadata;
            this.serviceName = this.metadata?.service_name || '';
            this.editingServiceName = false;
        } catch (e) {
            await this._showDriveError('용역명 저장 실패', this.getErrorMessage(e, '용역명을 저장하지 못했습니다.'));
        } finally {
            this.savingServiceName = false;
            await this.service.render();
        }
    }

    public async cancelEditServiceName() {
        this.serviceName = this.metadata?.service_name || '';
        this.editingServiceName = false;
        await this.service.render();
    }

    // ── 폴더 CRUD ──

    public async toggleNewFolder() {
        if (this.isCurrentFolderReadonly) {
            await this._showDriveError('읽기 전용 폴더', 'M-Pro 공유 폴더에는 새 폴더를 만들 수 없습니다.');
            return;
        }
        this.showNewFolder = !this.showNewFolder;
        this.newFolderName = '';
        await this.service.render();
    }

    public async createFolder() {
        if (this.isCurrentFolderReadonly) return;
        if (this.creatingFolder) return;
        if (!this.newFolderName.trim()) return;
        if (!await this._ensureMetadataIdle()) return;
        this.creatingFolder = true;
        await this.service.render();
        try {
            let res: any = await wiz.call("create_folder", {
                name: this.newFolderName.trim(),
                parent_id: this.currentFolder
            });
            if (res.code === 200) {
                this.showNewFolder = false;
                this.newFolderName = '';
                await this.load();
            } else {
                await this._showDriveError('폴더 생성 실패', this.getResponseMessage(res, '폴더를 만들지 못했습니다.'));
            }
        } catch (e) {
            await this._showDriveError('폴더 생성 실패', this.getErrorMessage(e, '폴더를 만들지 못했습니다.'));
        } finally {
            this.creatingFolder = false;
            await this.service.render();
        }
    }

    public async startRename(item: any, type: string) {
        if (this.isReadonlyItem(item)) return;
        if (!await this._ensureMetadataIdle()) return;
        this.editingId = type + ':' + item.id;
        this.editingName = item.name;
        await this.service.render();
    }

    public async confirmRename(item: any, type: string) {
        if (!this.editingName.trim()) return;
        if (!await this._ensureMetadataIdle()) return;
        if (type === 'folder') {
            await wiz.call("rename_folder", { folder_id: item.id, name: this.editingName.trim() });
        } else {
            await wiz.call("rename_file", { file_id: item.id, name: this.editingName.trim() });
        }
        this.editingId = '';
        await this.load();
    }

    public cancelRename() {
        this.editingId = '';
    }

    // ── 상위 폴더 이동 ──

    public async goUp() {
        if (this.breadcrumb.length > 1) {
            const parentId = this.breadcrumb[this.breadcrumb.length - 2].id;
            await this.openFolder(parentId);
        } else {
            await this.goRoot();
        }
    }

    // ── 행 선택 (단일 클릭 하이라이트) ──

    public async selectRow(key: string) {
        this.selectedItem = this.selectedItem === key ? '' : key;
        await this.service.render();
    }

    // ── 체크박스 선택 ──

    public async toggleCheck(key: string, event: any) {
        event.stopPropagation();
        if (this.isReadonlyId(key.substring(key.indexOf(':') + 1))) return;
        if (this.selectedItems.has(key)) {
            this.selectedItems.delete(key);
        } else {
            this.selectedItems.add(key);
        }
        await this.service.render();
    }

    public async toggleCheckAll() {
        if (this.isAllChecked) {
            this.selectedItems.clear();
        } else {
            for (const f of this.folders) if (!this.isReadonlyItem(f)) this.selectedItems.add('folder:' + f.id);
            for (const f of this.files) if (!this.isReadonlyItem(f)) this.selectedItems.add('file:' + f.id);
        }
        await this.service.render();
    }

    public get isAllChecked(): boolean {
        const total = this.folders.filter((item: any) => !this.isReadonlyItem(item)).length
            + this.files.filter((item: any) => !this.isReadonlyItem(item)).length;
        return total > 0 && this.selectedItems.size === total;
    }

    // ── 일괄 삭제 ──

    public async bulkDelete() {
        const count = this.selectedItems.size;
        if (count === 0) return;
        if (!await this._ensureMetadataIdle()) return;
        const deletesFile = Array.from(this.selectedItems).some((key: string) => key.startsWith('file:'));
        if (deletesFile && !await this._allowMetadataDraftDiscard('파일 삭제', '변경 취소하고 삭제')) return;
        let res = await this.service.modal.show({
            title: "선택 항목 삭제",
            message: `선택한 ${count}개 항목을 삭제하시겠습니까?`,
            action: "삭제",
            actionBtn: "error"
        });
        if (!res) return;
        for (const key of Array.from(this.selectedItems)) {
            const idx = key.indexOf(':');
            const type = key.substring(0, idx);
            const id = key.substring(idx + 1);
            if (type === 'folder') {
                await wiz.call("delete_folder", { folder_id: id });
            } else {
                await wiz.call("delete_file", { file_id: id });
            }
        }
        this.selectedItems.clear();
        await this.load();
    }

    public async deleteFolder(folderId: string) {
        if (this.isReadonlyId(folderId)) return;
        if (!await this._ensureMetadataIdle()) return;
        let res = await this.service.modal.show({ title: "폴더 삭제", message: "이 폴더와 하위 항목이 모두 삭제됩니다.", action: "삭제", actionBtn: "error" });
        if (!res) return;
        await wiz.call("delete_folder", { folder_id: folderId });
        await this.load();
    }

    // ── 업로드 ──

    private readonly uploadChunkSize: number = 8 * 1024 * 1024;

    private _newUploadId(): string {
        const cryptoApi: any = (window as any).crypto;
        if (cryptoApi?.randomUUID) return cryptoApi.randomUUID();
        const random = Math.random().toString(36).slice(2);
        return `${Date.now().toString(36)}-${random}-${random}`;
    }

    private async _uploadChunkWithProgress(
        fd: FormData,
        label: string,
        folderId: string,
        loadedBefore: number,
        totalBytes: number,
        chunkBytes: number,
    ): Promise<any> {
        const self = this;
        const action = `upload?folder_id=${encodeURIComponent(folderId || '')}`;
        const res: any = await wiz.call(action, fd, {
            contentType: false,
            processData: false,
            xhr: function () {
                const xhr = new XMLHttpRequest();
                xhr.upload.onprogress = (e: ProgressEvent) => {
                    if (!e.lengthComputable) return;
                    const chunkLoaded = Math.min(chunkBytes, e.loaded);
                    const loaded = Math.min(totalBytes, loadedBefore + chunkLoaded);
                    self.uploadPercent = totalBytes > 0 ? Math.round((loaded / totalBytes) * 100) : 100;
                    self.uploadProgress = `${label} — ${self.formatSize(loaded)} / ${self.formatSize(totalBytes)} (${self.uploadPercent}%)`;
                    self.service.render();
                };
                return xhr;
            }
        });
        if (res?.code !== 200) {
            throw new Error(this.getResponseMessage(res, '파일 업로드에 실패했습니다.'));
        }
        const completed = Math.min(totalBytes, loadedBefore + chunkBytes);
        this.uploadPercent = totalBytes > 0 ? Math.round((completed / totalBytes) * 100) : 100;
        this.uploadProgress = `${label} — ${this.formatSize(completed)} / ${this.formatSize(totalBytes)} (${this.uploadPercent}%)`;
        await this.service.render();
        return res;
    }

    private async _uploadFilesWithProgress(
        files: File[],
        label: string,
        folderId: string,
        uploadedBytes: number = 0,
        totalBytes: number = 0,
    ): Promise<any> {
        const localSize = files.reduce((sum: number, file: File) => sum + file.size, 0);
        const progressTotal = totalBytes > 0 ? totalBytes : localSize;
        const ids: string[] = [];
        let localUploaded = 0;

        for (let fileIndex = 0; fileIndex < files.length; fileIndex++) {
            const file = files[fileIndex];
            const uploadId = this._newUploadId();
            const chunkTotal = Math.max(1, Math.ceil(file.size / this.uploadChunkSize));
            let completed = false;

            for (let chunkIndex = 0; chunkIndex < chunkTotal; chunkIndex++) {
                const start = chunkIndex * this.uploadChunkSize;
                const end = Math.min(file.size, start + this.uploadChunkSize);
                const chunk = file.slice(start, end);
                const fd = new FormData();
                fd.append('folder_id', folderId);
                fd.append('upload_id', uploadId);
                fd.append('chunk_index', String(chunkIndex));
                fd.append('chunk_total', String(chunkTotal));
                fd.append('filename', file.name);
                fd.append('content_type', file.type || 'application/octet-stream');
                fd.append('file_size', String(file.size));
                fd.append('file[]', chunk, file.name);

                const fileLabel = files.length > 1
                    ? `${label} · ${file.name} (${fileIndex + 1}/${files.length})`
                    : `${label} · ${file.name}`;
                const res = await this._uploadChunkWithProgress(
                    fd,
                    fileLabel,
                    folderId,
                    uploadedBytes + localUploaded + start,
                    progressTotal,
                    chunk.size,
                );
                if (res?.data?.complete) {
                    ids.push(...this._uploadedIds(res));
                    completed = true;
                }
            }

            if (!completed) {
                throw new Error(`${file.name} 업로드 완료 응답을 확인하지 못했습니다.`);
            }
            localUploaded += file.size;
        }

        return { code: 200, data: { ids } };
    }

    private _resetUploadState() {
        this.uploading = false;
        this.uploadProgress = '';
        this.uploadPercent = 0;
    }

    private async _showDriveError(title: string, message: string) {
        await this.service.modal.show({
            title,
            message,
            action: '확인',
            cancel: false,
            status: 'error',
            actionBtn: 'error',
        });
    }

    private _uploadedIds(res: any): string[] {
        const ids = res?.data?.ids;
        return Array.isArray(ids) ? ids.filter((id: string) => !!id) : [];
    }

    private async _rollbackCreatedUpload(createdFolders: any[], uploadedFileIds: string[]): Promise<string[]> {
        const failures: string[] = [];
        const folderSeen = new Set<string>();
        const fileSeen = new Set<string>();

        for (const fileId of uploadedFileIds) {
            if (!fileId || fileSeen.has(fileId)) continue;
            fileSeen.add(fileId);
            try {
                const res: any = await wiz.call('delete_file', { file_id: fileId });
                if (res?.code !== 200) failures.push(fileId);
            } catch (e) {
                failures.push(fileId);
            }
        }

        for (const folder of [...createdFolders].reverse()) {
            const folderId = folder?.id;
            if (!folderId || folderSeen.has(folderId)) continue;
            folderSeen.add(folderId);
            try {
                const res: any = await wiz.call('delete_folder', { folder_id: folderId });
                if (res?.code !== 200) {
                    failures.push(folder?.path || folder?.name || folderId);
                }
            } catch (e) {
                failures.push(folder?.path || folder?.name || folderId);
            }
        }

        return failures;
    }

    private _cleanupMessage(createdFolders: any[], uploadedFileIds: string[], cleanupFailures: string[]): string {
        if (createdFolders.length === 0 && uploadedFileIds.length === 0) return '';
        if (cleanupFailures.length > 0) {
            return ' 이번 업로드에서 생성된 일부 항목은 정리하지 못했습니다. 목록을 새로고침한 뒤 남은 항목을 확인해주세요.';
        }
        return ' 이번 업로드에서 생성된 항목은 정리했습니다.';
    }

    private async _finishFolderUpload(bestFolderId: string) {
        if (bestFolderId) {
            this.currentFolder = bestFolderId;
            this.showMetaPanel = false;
        }

        try {
            await this.load();

            if (this.files.length > 0) {
                await this.generateMetadata(false);
            }
        } catch (e) {
            try {
                await this._showDriveError(
                    '폴더 업로드 후처리 실패',
                    this.getErrorMessage(e, '업로드는 완료됐지만 목록 갱신 또는 자동 분류에 실패했습니다. 새로고침 후 확인해주세요.')
                );
            } catch (_modalError) {
                // 후처리 알림 실패가 업로드 롤백으로 전파되지 않게 막는다.
            }
        }
    }

    public async uploadFiles() {
        if (this.isCurrentFolderReadonly) {
            await this._showDriveError('읽기 전용 폴더', 'M-Pro 공유 폴더에는 파일을 업로드할 수 없습니다.');
            return;
        }
        let input = document.createElement('input');
        input.type = 'file';
        input.multiple = true;
        input.onchange = async () => {
            if (!input.files || input.files.length === 0) return;
            if (!await this._allowMetadataDraftDiscard('파일 업로드', '변경 취소하고 업로드')) return;

            let uploaded = false;
            try {
                const totalSize = Array.from(input.files).reduce((s, f) => s + f.size, 0);
                this.uploading = true;
                this.uploadPercent = 0;
                this.uploadProgress = `파일 ${input.files.length}개 (${this.formatSize(totalSize)}) 업로드 준비 중...`;
                await this.service.render();

                await this._uploadFilesWithProgress(
                    Array.from(input.files),
                    `파일 ${input.files.length}개`,
                    this.currentFolder,
                    0,
                    totalSize,
                );
                uploaded = true;
            } catch (e) {
                this._resetUploadState();
                await this.service.render();
                await this._showDriveError('파일 업로드 실패', this.getErrorMessage(e, '파일 업로드에 실패했습니다.'));
            }

            this._resetUploadState();
            await this.load();

            // 현재 폴더에 파일이 있으면 자동 분류
            if (uploaded && this.files.length > 0) {
                await this.generateMetadata(false);
            }
        };
        input.click();
    }

    public async uploadFolder() {
        if (this.isCurrentFolderReadonly) {
            await this._showDriveError('읽기 전용 폴더', 'M-Pro 공유 폴더에는 폴더를 업로드할 수 없습니다.');
            return;
        }
        let input = document.createElement('input');
        input.type = 'file';
        (input as any).webkitdirectory = true;
        input.onchange = async () => {
            if (!input.files || input.files.length === 0) return;
            if (!await this._allowMetadataDraftDiscard('폴더 업로드', '변경 취소하고 업로드')) return;

            this.uploading = true;
            this.uploadPercent = 0;
            this.uploadProgress = `폴더 구조 분석 중... (${input.files.length}개 파일)`;
            await this.service.render();

            const pathMap: Map<string, File[]> = new Map();
            const allPaths: Set<string> = new Set();

            for (let i = 0; i < input.files.length; i++) {
                const file = input.files[i];
                const relPath = (file as any).webkitRelativePath || file.name;
                const parts = relPath.split('/');
                const folderPath = parts.slice(0, -1).join('/');

                if (!pathMap.has(folderPath)) pathMap.set(folderPath, []);
                pathMap.get(folderPath)!.push(file);

                for (let j = 1; j <= parts.length - 1; j++) {
                    allPaths.add(parts.slice(0, j).join('/'));
                }
            }

            const sortedPaths = Array.from(allPaths).sort();
            const folderIdMap: Map<string, string> = new Map();
            folderIdMap.set('', this.currentFolder);
            const createdFolders: any[] = [];
            const uploadedFileIds: string[] = [];

            try {
                for (const path of sortedPaths) {
                    const parts = path.split('/');
                    const folderName = parts[parts.length - 1];
                    const parentPath = parts.slice(0, -1).join('/');
                    const parentId = folderIdMap.get(parentPath);
                    if (typeof parentId === 'undefined') {
                        throw new Error(`${path} 생성 실패: 상위 폴더를 확인할 수 없습니다.`);
                    }

                    this.uploadProgress = `폴더 생성: ${path}`;
                    await this.service.render();

                    const res: any = await wiz.call("create_folder", { name: folderName, parent_id: parentId });
                    if (res.code === 200 && res.data?.id) {
                        folderIdMap.set(path, res.data.id);
                        createdFolders.push({ id: res.data.id, path, name: folderName });
                    } else {
                        throw new Error(`${path} 생성 실패: ${this.getResponseMessage(res, '폴더를 만들지 못했습니다.')}`);
                    }
                }

                const totalFiles = input.files.length;
                const totalSize = Array.from(input.files).reduce((s, f) => s + f.size, 0);
                let uploadedFiles = 0;
                let uploadedBytes = 0;

                // 파일이 가장 많이 업로드된 폴더 추적
                let bestFolderId = '';
                let bestFileCount = 0;

                for (const [folderPath, files] of pathMap.entries()) {
                    const targetFolderId = folderIdMap.get(folderPath);
                    if (typeof targetFolderId === 'undefined') {
                        throw new Error(`${folderPath || '루트'} 업로드 실패: 대상 폴더를 확인할 수 없습니다.`);
                    }
                    const batchSize = files.reduce((s, f) => s + f.size, 0);

                    if (files.length > bestFileCount) {
                        bestFileCount = files.length;
                        bestFolderId = targetFolderId;
                    }

                    const batchLabel = `${folderPath || '루트'} (${uploadedFiles}/${totalFiles} 파일, ${this.formatSize(uploadedBytes)} / ${this.formatSize(totalSize)})`;
                    try {
                        const res = await this._uploadFilesWithProgress(
                            files,
                            batchLabel,
                            targetFolderId,
                            uploadedBytes,
                            totalSize,
                        );
                        uploadedFileIds.push(...this._uploadedIds(res));
                    } catch (e) {
                        throw new Error(`${folderPath || '루트'} 업로드 실패: ${this.getErrorMessage(e, '파일 업로드에 실패했습니다.')}`);
                    }
                    uploadedFiles += files.length;
                    uploadedBytes += batchSize;
                }

                this._resetUploadState();

                await this._finishFolderUpload(bestFolderId);
            } catch (e) {
                this.uploadProgress = '업로드 실패 항목 정리 중...';
                await this.service.render();
                const cleanupFailures = await this._rollbackCreatedUpload(createdFolders, uploadedFileIds);
                const cleanupMessage = this._cleanupMessage(createdFolders, uploadedFileIds, cleanupFailures);
                this._resetUploadState();
                await this.load();
                await this._showDriveError('폴더 업로드 실패', this.getErrorMessage(e, '폴더 업로드에 실패했습니다.') + cleanupMessage);
            }
        };
        input.click();
    }

    public async deleteFile(fileId: string) {
        if (this.isReadonlyId(fileId)) return;
        if (!await this._allowMetadataDraftDiscard('파일 삭제', '변경 취소하고 삭제')) return;
        let res = await this.service.modal.show({ title: "파일 삭제", message: "이 파일을 삭제하시겠습니까?", action: "삭제", actionBtn: "error" });
        if (!res) return;
        await wiz.call("delete_file", { file_id: fileId });
        if (this.previewFile?.id === fileId) this.closePreview();
        await this.load();
    }

    public get missingFileCount(): number {
        return this.files.filter((file: any) => this.isMissingFile(file)).length;
    }

    public async cleanupMissingFiles() {
        if (this.missingFileCount === 0) return;
        if (!await this._allowMetadataDraftDiscard('누락 파일 정리', '변경 취소하고 정리')) return;
        const ok = await this.service.modal.show({
            title: '누락 파일 정리',
            message: `현재 목록에서 원본이 없는 파일 기록 ${this.missingFileCount}개를 삭제하시겠습니까?`,
            action: '정리',
            actionBtn: 'error',
        });
        if (!ok) return;
        await wiz.call('cleanup_missing_files', { folder_id: this.currentFolder });
        await this.load();
    }

    public isMissingFile(file: any): boolean {
        return !!file && (file.missing_on_disk === true || file.disk_exists === false || file.downloadable === false);
    }

    public isReadonlyId(id: string): boolean {
        const value = String(id || '');
        return value.startsWith('mprof') || value.startsWith('mproi');
    }

    public isReadonlyItem(item: any): boolean {
        return !!item && (item.readonly === true || item.source === 'mpro' || this.isReadonlyId(item.id));
    }

    public get isCurrentFolderReadonly(): boolean {
        if (this.isSharedDrive || this.driveView?.readonly === true) return true;
        if (this.isReadonlyId(this.currentFolder)) return true;
        const current = this.breadcrumb.length > 0 ? this.breadcrumb[this.breadcrumb.length - 1] : null;
        return this.isReadonlyItem(current);
    }

    private async showMissingFileNotice(file: any) {
        const name = file?.name || '선택한 파일';
        await this.service.modal.show({
            title: '원본 파일 없음',
            message: `${name}의 원본 파일이 서버 디스크에 없습니다. 프로젝트 복사 시 data/drive 폴더가 함께 복사되지 않은 것 같습니다. 파일을 다시 업로드해주세요.`,
            action: '확인',
            cancel: false,
            status: 'warning',
        });
    }

    public async downloadFile(fileOrId: any) {
        const file = typeof fileOrId === 'object'
            ? fileOrId
            : this.files.find((item: any) => item.id === fileOrId);
        const fileId = typeof fileOrId === 'object' ? fileOrId?.id : fileOrId;
        if (!fileId) return;
        if (this.isMissingFile(file)) {
            await this.showMissingFileNotice(file);
            return;
        }
        window.open(`/api/drive/file.download?file_id=${encodeURIComponent(fileId)}`, '_blank');
    }

    public isPreviewableFile(file: any): boolean {
        const name = this.normalizedFileName(file);
        const mimetype = String(file?.mimetype || '').toLowerCase();
        return mimetype.includes('pdf')
            || mimetype.startsWith('image/')
            || mimetype.startsWith('text/')
            || name.endsWith('.pdf')
            || name.endsWith('.txt')
            || name.endsWith('.md')
            || name.endsWith('.csv')
            || name.endsWith('.json');
    }

    public normalizedFileName(file: any): string {
        return String(file?.name || file?.filename || file?.file_name || file?.original_name || '').toLowerCase();
    }

    public isSpreadsheetFile(file: any): boolean {
        const name = this.normalizedFileName(file);
        const mimetype = String(file?.mimetype || '').toLowerCase();
        return mimetype.includes('spreadsheet')
            || mimetype.includes('excel')
            || mimetype.includes('sheet')
            || name.endsWith('.xlsx')
            || name.endsWith('.xlsm')
            || name.endsWith('.xltx')
            || name.endsWith('.xltm')
            || name.endsWith('.xls');
    }

    public isXlsxFile(file: any): boolean {
        const name = this.normalizedFileName(file);
        const mimetype = String(file?.mimetype || '').toLowerCase();
        return name.endsWith('.xlsx')
            || name.endsWith('.xlsm')
            || name.endsWith('.xltx')
            || name.endsWith('.xltm')
            || mimetype.includes('spreadsheetml')
            || mimetype.includes('openxmlformats-officedocument.spreadsheetml');
    }

    public isHwpFile(file: any): boolean {
        const name = this.normalizedFileName(file);
        return name.endsWith('.hwp') || name.endsWith('.hwpx');
    }

    public isPdfFile(file: any): boolean {
        const name = this.normalizedFileName(file);
        const mimetype = String(file?.mimetype || '').toLowerCase();
        return mimetype.includes('pdf') || name.endsWith('.pdf');
    }

    public isSidePreviewableFile(file: any): boolean {
        return this.isPdfFile(file) || this.isSpreadsheetFile(file) || this.isHwpFile(file);
    }

    public previewTypeLabel(file: any): string {
        if (this.isPdfFile(file)) return 'PDF';
        if (this.isSpreadsheetFile(file)) return 'XLSX';
        if (this.isHwpFile(file)) return 'HWP';
        return 'FILE';
    }

    public closePreview() {
        this.previewFile = null;
        this.previewUrl = '';
    }

    public async openPreview(file: any) {
        if (!file?.id) return;
        if (this.isMissingFile(file)) {
            await this.showMissingFileNotice(file);
            return;
        }
        this.previewFile = file;
        const action = this.isPdfFile(file) ? 'file.view' : 'file.preview';
        this.previewUrl = `/api/drive/${action}?file_id=${encodeURIComponent(file.id)}`;
        await this.service.render();
    }

    public isInspectableFile(file: any): boolean {
        if (this.isMissingFile(file)) return false;
        const name = String(file?.name || file?.filename || '').toLowerCase();
        return name.endsWith('.pdf') || name.endsWith('.hwp') || name.endsWith('.hwpx') || name.endsWith('.xlsx') || name.endsWith('.xlsm');
    }

    public get inspectableFiles(): any[] {
        return this.files.filter((file: any) => this.isInspectableFile(file));
    }

    public get hasInspectableFiles(): boolean {
        return this.inspectableFiles.length > 0 || this.fileCount > this.files.length;
    }

    public async openFile(file: any) {
        if (!file?.id) return;
        if (this.editingId === 'file:' + file.id) return;
        if (this.isMissingFile(file)) {
            await this.showMissingFileNotice(file);
            return;
        }

        if (this.isSidePreviewableFile(file)) {
            await this.openPreview(file);
            return;
        }

        if (this.isPreviewableFile(file)) {
            window.open(`/api/drive/file.view?file_id=${encodeURIComponent(file.id)}`, '_blank');
            return;
        }

        await this.service.modal.show({
            title: '미리보기 미지원',
            message: '이 파일 형식은 브라우저 미리보기가 어려워 다운로드로 열겠습니다.',
            action: '다운로드',
            cancel: false,
            status: 'warning',
        });
        await this.downloadFile(file);
    }

    private getResponseMessage(response: any, fallback: string): string {
        if (!response) return fallback;
        if (typeof response === 'string') return response;
        if (response?.data?.message) return response.data.message;
        if (response?.message) return response.message;
        try {
            const text = JSON.stringify(response);
            return text && text !== '{}' ? text : fallback;
        } catch (e) {
            return fallback;
        }
    }

    private getErrorMessage(error: any, fallback: string): string {
        if (!error) return fallback;
        const rawText = typeof error === 'string' ? error : String(error?.responseText || '');
        if (Number(error?.status || error?.code) === 413 || /413\s+Payload Too Large/i.test(rawText)) {
            return '업로드 요청 용량이 서버 한도를 초과했습니다. 화면을 새로고침한 뒤 다시 시도해주세요.';
        }
        if (typeof error === 'string') return error;
        if (error?.data?.message) return error.data.message;
        if (error?.responseJSON?.data?.message) return error.responseJSON.data.message;
        if (error?.responseJSON?.message) return error.responseJSON.message;
        const responseMessage = this.getResponseMessage(error, '');
        if (responseMessage) return responseMessage;
        if (error?.message) return error.message;
        try {
            const text = JSON.stringify(error);
            return text && text !== '{}' ? text : fallback;
        } catch (e) {
            return fallback;
        }
    }

    private _currentFolderName(): string {
        if (this.breadcrumb.length > 0) {
            return this.breadcrumb[this.breadcrumb.length - 1].name || '홈';
        }
        return '홈';
    }

    private _resetInspectionSelector() {
        this.showInspectionSelector = false;
        this.inspectionCandidates = [];
        this.inspectionSelection = {};
        this.inspectionCandidatePolicy = null;
    }

    private _applyInspectionDefaults(candidates: any[] = []) {
        const selection: any = {};
        for (const item of candidates) {
            if (!item?.id) continue;
            selection[item.id] = item.default_selected === true;
        }
        this.inspectionSelection = selection;
    }

    public get selectedInspectionCount(): number {
        return this.inspectionCandidates.filter((item: any) => this.inspectionSelection[item.id] === true).length;
    }

    public get selectedInspectionFileIds(): string[] {
        return this.inspectionCandidates
            .filter((item: any) => this.inspectionSelection[item.id] === true)
            .map((item: any) => item.id)
            .filter((id: string) => !!id);
    }

    public get inspectionPolicyText(): string {
        const policy = this.inspectionCandidatePolicy || {};
        const candidateCount = policy.candidate_count || this.inspectionCandidates.length || 0;
        const defaultCount = policy.default_count || 0;
        const reportCount = policy.report_count || 0;

        if (!policy.metadata_present) {
            return `메타데이터가 없어 검사 가능 파일 ${candidateCount}개를 표시합니다. 기본 선택 없이 필요한 파일을 직접 선택하세요.`;
        }
        if (reportCount === 0) {
            return `메타데이터는 있지만 role=report 파일이 없습니다. 검사할 파일을 직접 선택하세요.`;
        }
        if (defaultCount === 0) {
            return `role=report 파일 ${reportCount}개가 있지만 기본 선택할 최신 보고서를 확정하지 못했습니다. 검사할 파일을 직접 선택하세요.`;
        }
        const latestName = policy.latest_report_name ? ` (${policy.latest_report_name})` : '';
        return `role=report 파일 ${reportCount}개 중 수정일자가 가장 최신인 보고서${latestName}를 기본 선택했습니다.`;
    }

    public get inspectionDuplicateText(): string {
        const count = this.inspectionCandidatePolicy?.duplicate_suppressed_count || 0;
        if (!count) return '';
        return `같은 basename의 PDF가 있는 HWP/HWPX ${count}개는 기본 선택에서 제외했습니다.`;
    }

    public inspectionRoleLabel(role: string): string {
        return role ? this.roleLabel(role) : '미분류';
    }

    public inspectionRoleColor(role: string): string {
        return role ? this.roleColor(role) : 'bg-gray-100 text-gray-600';
    }

    public setInspectionSelected(fileId: string, selected: boolean) {
        if (!fileId) return;
        this.inspectionSelection[fileId] = selected === true;
    }

    public async selectAllInspectionCandidates() {
        for (const item of this.inspectionCandidates) {
            if (item?.id) this.inspectionSelection[item.id] = true;
        }
        await this.service.render();
    }

    public async clearInspectionCandidates() {
        for (const item of this.inspectionCandidates) {
            if (item?.id) this.inspectionSelection[item.id] = false;
        }
        await this.service.render();
    }

    public async resetInspectionDefaults() {
        this._applyInspectionDefaults(this.inspectionCandidates);
        await this.service.render();
    }

    public async closeInspectionSelector() {
        this._resetInspectionSelector();
        await this.service.render();
    }

    public async confirmInspectionSelection() {
        const fileIds = this.selectedInspectionFileIds;
        if (fileIds.length === 0) {
            await this.service.modal.show({
                title: '검사 파일 없음',
                message: '검사할 파일을 하나 이상 선택해주세요.',
                action: '확인',
                cancel: false,
                status: 'warning',
            });
            return;
        }
        this.showInspectionSelector = false;
        await this._createInspection(fileIds);
    }

    private async _createInspection(fileIds: string[]) {
        if (this.creatingInspection) return;
        if (fileIds.length === 0) {
            await this.service.modal.show({
                title: '검사 파일 없음',
                message: '검사할 PDF/HWP/HWPX/Excel 파일이 없습니다.',
                action: '확인',
                cancel: false,
                status: 'warning',
            });
            return;
        }

        this.creatingInspection = true;
        await this.service.render();

        try {
            const res: any = await wiz.call('create_inspection_from_drive', {
                folder_id: this.currentFolder,
                folder_name: this._currentFolderName(),
                file_ids: JSON.stringify(fileIds),
            });

            if (res.code === 200 && res.data?.session_id) {
                this.service.href(`/chatbot/room/${res.data.session_id}`);
                return;
            }

            await this.service.modal.show({
                title: '검사 시작 실패',
                message: res.data?.message || '검사 세션을 만들지 못했습니다.',
                action: '확인',
                cancel: false,
                status: 'error',
            });
        } catch (e) {
            await this.service.modal.show({
                title: '검사 시작 실패',
                message: this.getErrorMessage(e, '검사 세션을 만들지 못했습니다.'),
                action: '확인',
                cancel: false,
                status: 'error',
            });
        }

        this.creatingInspection = false;
        await this.service.render();
    }

    public async startInspectionFromFolder() {
        if (this.creatingInspection) return;
        this.creatingInspection = true;
        await this.service.render();

        try {
            const res: any = await wiz.call('get_inspection_candidates', {
                folder_id: this.currentFolder,
            });

            if (res.code !== 200) {
                await this.service.modal.show({
                    title: '검사 대상 확인 실패',
                    message: res.data?.message || '검사 대상 파일을 확인하지 못했습니다.',
                    action: '확인',
                    cancel: false,
                    status: 'error',
                });
                return;
            }

            const candidates = Array.isArray(res.data?.candidates) ? res.data.candidates : [];
            if (candidates.length === 0) {
                await this.service.modal.show({
                    title: '검사 파일 없음',
                    message: '검사할 PDF/HWP/HWPX/Excel 파일이 없습니다.',
                    action: '확인',
                    cancel: false,
                    status: 'warning',
                });
                return;
            }

            this.inspectionCandidates = candidates;
            this.inspectionCandidatePolicy = res.data?.policy || {};
            this._applyInspectionDefaults(candidates);
            this.showInspectionSelector = true;
        } catch (e) {
            await this.service.modal.show({
                title: '검사 대상 확인 실패',
                message: this.getErrorMessage(e, '검사 대상 파일을 확인하지 못했습니다.'),
                action: '확인',
                cancel: false,
                status: 'error',
            });
        } finally {
            this.creatingInspection = false;
            await this.service.render();
        }
    }

    public async startInspectionFromFile(file: any) {
        if (this.isMissingFile(file)) {
            await this.showMissingFileNotice(file);
            return;
        }
        if (!this.isInspectableFile(file)) {
            await this.service.modal.show({
                title: '검사 불가 파일',
                message: '검사는 PDF, HWP, HWPX, Excel 파일만 지원합니다.',
                action: '확인',
                cancel: false,
                status: 'warning',
            });
            return;
        }
        await this._createInspection([file.id]);
    }

    public async createSampleDataset() {
        if (this.creatingDataset) return;
        if (!await this._allowMetadataDraftDiscard('검사용 데이터셋 생성', '변경 취소하고 생성')) return;
        this.creatingDataset = true;
        await this.service.render();

        try {
            const res: any = await wiz.call('create_sample_dataset');
            if (res.code === 200) {
                const folders = res.data?.folders || [];
                if (folders.length > 0) {
                    const targetFolder = folders.reduce((best: any, folder: any) => {
                        return (folder.file_count || 0) > (best.file_count || 0) ? folder : best;
                    }, folders[0]);
                    this.currentFolder = targetFolder.id;
                    this.page = 1;
                    this.searchText = '';
                    this.showMetaPanel = false;
                    this.editingServiceName = false;
                }
                await this.load();
                await this.service.modal.show({
                    title: '검사용 데이터셋 생성',
                    message: `폴더 ${res.data?.folder_count || folders.length}개, 파일 ${res.data?.file_count || 0}개를 준비했습니다.`,
                    action: '확인',
                    cancel: false,
                    status: 'success',
                });
                this.creatingDataset = false;
                await this.service.render();
                return;
            }

            await this.service.modal.show({
                title: '데이터셋 생성 실패',
                message: res.data?.message || '검사용 데이터셋을 만들지 못했습니다.',
                action: '확인',
                cancel: false,
                status: 'error',
            });
        } catch (e) {
            await this.service.modal.show({
                title: '데이터셋 생성 실패',
                message: this.getErrorMessage(e, '검사용 데이터셋을 만들지 못했습니다.'),
                action: '확인',
                cancel: false,
                status: 'error',
            });
        }

        this.creatingDataset = false;
        await this.service.render();
    }

    // ── 메타데이터 ──

    public async generateMetadata(showPanel: boolean = true) {
        if (this.generatingMeta) return;
        if (!await this._allowMetadataDraftDiscard('AI 재분류', '변경 취소하고 재분류')) return;
        this.generatingMeta = true;
        this.metaProgress = '파일 정보 수집 중...';
        this.metaPercent = 10;
        await this.service.render();

        await new Promise(r => setTimeout(r, 300));
        this.metaProgress = `AI 파일 분류 분석 중... (${this.files.length}개 파일)`;
        this.metaPercent = 25;
        await this.service.render();

        const progressTimer = setInterval(async () => {
            if (this.metaPercent < 85) {
                this.metaPercent += Math.floor(Math.random() * 8) + 2;
                if (this.metaPercent > 85) this.metaPercent = 85;
                await this.service.render();
            }
        }, 600);

        try {
            const res: any = await wiz.call("generate_metadata", { folder_id: this.currentFolder });
            clearInterval(progressTimer);

            if (res.code === 200 && res.data?.metadata) {
                this.metadata = res.data.metadata;
                this.serviceName = this.metadata?.service_name || '';
                this._resetMetadataDraftRoles();
                this.metaPercent = 100;
                this.metaProgress = '분류 완료!';
                await this.service.render();
                await new Promise(r => setTimeout(r, 800));
                if (showPanel) this.showMetaPanel = true;
            } else {
                this.metaProgress = '분류 실패';
                this.metaPercent = 0;
                await this.service.render();
                await new Promise(r => setTimeout(r, 1500));
            }
        } catch (e) {
            clearInterval(progressTimer);
            this.metaProgress = '분류 실패';
            this.metaPercent = 0;
            await this.service.render();
            await new Promise(r => setTimeout(r, 1500));
        }

        this.generatingMeta = false;
        this.metaProgress = '';
        this.metaPercent = 0;
        await this.service.render();
    }

    private _resetMetadataDraftRoles() {
        const drafts: { [fileId: string]: string } = {};
        const files = Array.isArray(this.metadata?.files) ? this.metadata.files : [];
        for (const file of files) {
            if (!file?.id) continue;
            drafts[String(file.id)] = this.normalizeRole(file.role) || 'other';
        }
        this.metadataDraftRoles = drafts;
        this.metadataSavedRoles = { ...drafts };
        this.metadataDraftFolderId = this.currentFolder;
        this.metadataReviewMessage = '';
    }

    private async _allowMetadataDraftDiscard(title: string, action: string): Promise<boolean> {
        if (!await this._ensureMetadataIdle()) return false;
        if (this.metadataPendingCount === 0) return true;
        const ok = await this.service.modal.show({
            title,
            message: '아직 저장하지 않은 파일 역할 변경이 있습니다. 변경을 취소하고 계속하시겠습니까?',
            action,
            status: 'warning',
        });
        if (!ok) return false;
        this._resetMetadataDraftRoles();
        return true;
    }

    private async _ensureMetadataIdle(): Promise<boolean> {
        if (this.metadataBusy) {
            await this.service.modal.show({
                title: '메타데이터 작업 진행 중',
                message: '현재 작업이 끝난 뒤 다시 시도해주세요.',
                action: '확인',
                cancel: false,
                status: 'warning',
            });
            return false;
        }
        return true;
    }

    public getMetadataDraftRole(fileId: string, fallbackRole: string = ''): string {
        const key = String(fileId || '');
        if (Object.prototype.hasOwnProperty.call(this.metadataDraftRoles, key)) {
            return this.metadataDraftRoles[key];
        }
        return this.normalizeRole(fallbackRole) || 'other';
    }

    public isMetadataRoleDirty(fileId: string): boolean {
        const key = String(fileId || '');
        if (!key || !Object.prototype.hasOwnProperty.call(this.metadataSavedRoles, key)) return false;
        return this.getMetadataDraftRole(key) !== this.metadataSavedRoles[key];
    }

    public async stageMetadataRole(fileId: string, role: string) {
        if (this.metadataBusy) return;
        const normalized = this.normalizeRole(role);
        if (!fileId || !normalized) return;
        this.metadataDraftRoles[String(fileId)] = normalized;
        this.metadataReviewMessage = '';
        await this.service.render();
    }

    public async applyBulkMetadataRole(role: string) {
        if (this.metadataBusy) return;
        const normalized = this.normalizeRole(role);
        if (!normalized || !Array.isArray(this.metadata?.files)) return;
        for (const file of this.metadata.files) {
            if (!file?.id) continue;
            this.metadataDraftRoles[String(file.id)] = normalized;
        }
        this.metadataReviewMessage = `모든 파일을 '${this.roleLabel(normalized)}' 역할로 선택했습니다. 아래 확인 버튼을 눌러 저장하세요.`;
        await this.service.render();
    }

    public async discardMetadataChanges() {
        if (this.metadataBusy) return;
        this._resetMetadataDraftRoles();
        this.metadataReviewMessage = '저장하지 않은 역할 변경을 취소했습니다.';
        await this.service.render();
    }

    public async confirmMetadataClassification() {
        if (!this.canConfirmMetadata) return;
        const folderId = this.currentFolder;
        this.confirmingMetadata = true;
        this.metadataReviewMessage = '';
        await this.service.render();

        try {
            const res: any = await wiz.call("confirm_metadata", {
                folder_id: folderId,
                roles: JSON.stringify(this.metadataDraftRoles),
                baseline_roles: JSON.stringify(this.metadataSavedRoles),
                baseline_revision: this.metadata?.classification_revision || '',
            });
            if (res?.code !== 200 || !res.data?.metadata) {
                throw new Error(this.getResponseMessage(res, '파일 분류를 저장하지 못했습니다.'));
            }
            if (folderId !== this.currentFolder) return;
            this.metadata = res.data.metadata;
            this.serviceName = this.metadata?.service_name || this.serviceName;
            this._resetMetadataDraftRoles();
            this.metadataReviewMessage = '파일 분류를 확인하고 저장했습니다.';
        } catch (e) {
            this.metadataReviewMessage = '저장하지 못했습니다. 선택한 내용은 유지됩니다.';
            await this._showDriveError(
                '파일 분류 저장 실패',
                this.getErrorMessage(e, '파일 분류를 저장하지 못했습니다.')
            );
        } finally {
            this.confirmingMetadata = false;
            await this.service.render();
        }
    }

    public get metadataPendingCount(): number {
        if (!Array.isArray(this.metadata?.files)) return 0;
        return this.metadata.files.filter((file: any) => this.isMetadataRoleDirty(file?.id)).length;
    }

    public get isMetadataConfirmed(): boolean {
        return this.metadataPendingCount === 0
            && String(this.metadata?.classification_status || '') === 'confirmed'
            && !!this.metadata?.confirmed_at;
    }

    public get canConfirmMetadata(): boolean {
        return !this.metadataBusy
            && Array.isArray(this.metadata?.files)
            && this.metadata.files.length > 0
            && !this.editingServiceName
            && !this.isMetadataConfirmed;
    }

    public get metadataBusy(): boolean {
        return this.generatingMeta
            || this.confirmingMetadata
            || this.uploading
            || this.savingServiceName
            || this.movingItem
            || this.editingServiceName;
    }

    public get metadataReviewStatusLabel(): string {
        if (this.confirmingMetadata) return '분류 저장 중';
        if (this.metadataPendingCount > 0) return `변경사항 ${this.metadataPendingCount}개`;
        if (this.isMetadataConfirmed) return '분류 확인 완료';
        return '분류 확인 필요';
    }

    public get metadataReviewStatusDescription(): string {
        if (this.metadataReviewMessage) return this.metadataReviewMessage;
        if (this.confirmingMetadata) return '선택한 파일 역할을 저장하고 있습니다.';
        if (this.editingServiceName) return '용역명 편집을 저장하거나 취소한 뒤 파일 분류를 확인해주세요.';
        if (this.metadataPendingCount > 0) return '변경한 역할을 확인한 뒤 저장해주세요.';
        if (this.isMetadataConfirmed) return '모든 파일 역할이 사람의 확인을 거쳐 저장되었습니다.';
        return 'AI 분류 결과를 검토한 뒤 이대로 분류 확인 버튼을 눌러주세요.';
    }

    public get metadataConfirmButtonLabel(): string {
        if (this.confirmingMetadata) return '저장 중...';
        if (this.metadataPendingCount > 0) return `변경 ${this.metadataPendingCount}개 확인 및 저장`;
        if (this.isMetadataConfirmed) return '확인 완료';
        return '이대로 분류 확인';
    }

    public getFileRole(fileId: string): string {
        if (!this.metadata?.files) return '';
        const f = this.metadata.files.find((m: any) => m.id === fileId);
        return f?.role || '';
    }

    public getFileDescription(fileId: string): string {
        if (!this.metadata?.files) return '';
        const f = this.metadata.files.find((m: any) => m.id === fileId);
        return f?.description || '';
    }

    public async toggleMetaPanel() {
        if (this.metadataBusy) return;
        if (!this.showMetaPanel && Object.keys(this.metadataDraftRoles).length === 0) {
            this._resetMetadataDraftRoles();
        }
        this.showMetaPanel = !this.showMetaPanel;
        await this.service.render();
    }

    public roleLabel(role: string): string {
        const normalized = this.normalizeRole(role);
        const labels: any = { report: '보고서', reference: '전차보고서 DB', '부록': '부록', appendix: '부록', contract: '계약서', kickoff: '착수계', ledger: '관리대장', other: '기타' };
        return labels[normalized] || normalized;
    }

    public roleColor(role: string): string {
        const normalized = this.normalizeRole(role);
        const colors: any = {
            report: 'bg-blue-100 text-blue-700',
            reference: 'bg-cyan-100 text-cyan-700',
            '부록': 'bg-yellow-100 text-yellow-700',
            appendix: 'bg-yellow-100 text-yellow-700',
            contract: 'bg-amber-100 text-amber-700',
            kickoff: 'bg-emerald-100 text-emerald-700',
            ledger: 'bg-purple-100 text-purple-700',
            other: 'bg-gray-100 text-gray-600'
        };
        return colors[normalized] || 'bg-gray-100 text-gray-600';
    }

    public normalizeRole(role: string): string {
        const text = String(role || '').trim().toLowerCase();
        if (!text) return '';
        if (['appendix', '부록', '부록자료', '첨부', '첨부자료', '별첨'].includes(text)) return '부록';
        if (['additional', 'other', '기타'].includes(text)) return 'other';
        if (['reference', 'previous', 'previous_report', '전차', '전차보고서', '전차 보고서', '이전보고서', '이전 보고서'].includes(text)) return 'reference';
        if (text === '보고서') return 'report';
        if (text === '계약서') return 'contract';
        if (text === '착수계') return 'kickoff';
        if (text === '관리대장') return 'ledger';
        return text;
    }

    public countByRole(role: string): number {
        if (!this.metadata?.files) return 0;
        const normalized = this.normalizeRole(role);
        return this.metadata.files.filter((f: any) => {
            const currentRole = this.showMetaPanel
                ? this.getMetadataDraftRole(f?.id, f?.role)
                : this.normalizeRole(f?.role);
            return currentRole === normalized;
        }).length;
    }

    public get isSharedDrive(): boolean {
        return this.driveViewScope === 'shared';
    }

    // ── 검색 ──

    public async search() {
        if (!await this._allowMetadataDraftDiscard('파일 검색', '변경 취소하고 검색')) return;
        this.page = 1;
        await this.load();
    }

    public async clearSearch() {
        if (!await this._allowMetadataDraftDiscard('검색 초기화', '변경 취소하고 초기화')) return;
        this.searchText = '';
        this.page = 1;
        await this.load();
    }

    // ── 포맷 ──

    public formatSize(bytes: number): string {
        if (!bytes) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB'];
        let i = 0;
        let size = bytes;
        while (size >= 1024 && i < units.length - 1) { size /= 1024; i++; }
        return size.toFixed(i === 0 ? 0 : 1) + ' ' + units[i];
    }

    // ── 페이지네이션 ──

    public get totalPages(): number { return Math.ceil(this.fileCount / this.dump); }

    public async goPage(p: number) {
        if (p < 1 || p > this.totalPages) return;
        if (!await this._allowMetadataDraftDiscard('페이지 이동', '변경 취소하고 이동')) return;
        this.page = p;
        await this.load();
    }

    // ── Drag & Drop ──

    private _targetKey(folderId: string): string {
        return folderId || '__root__';
    }

    private _canDropItemToFolder(item: any, folderId: string): boolean {
        if (!item || !item.id || !item.type) return false;
        if (this.isReadonlyItem(item) || this.isReadonlyId(folderId)) return false;
        const targetFolderId = folderId || '';
        if (this.currentFolder === targetFolderId) return false;
        if (item.type === 'folder' && item.id === targetFolderId) return false;
        return true;
    }

    private _readDragItem(event: any): any {
        if (this.draggingItem) return this.draggingItem;
        const data = event?.dataTransfer?.getData(this.driveDragMime);
        if (!data) return null;
        try {
            return JSON.parse(data);
        } catch (e) {
            return null;
        }
    }

    private _clearDragState() {
        this.draggingItem = null;
        this.dragOverFolderId = '';
    }

    public canDropToFolderId(folderId: string): boolean {
        return this._canDropItemToFolder(this.draggingItem, folderId);
    }

    public isMoveTargetActive(folderId: string): boolean {
        return this.dragOverFolderId === this._targetKey(folderId) && this.canDropToFolderId(folderId);
    }

    public isDragging(type: string, id: string): boolean {
        return !!this.draggingItem && this.draggingItem.type === type && this.draggingItem.id === id;
    }

    public onItemDragStart(event: any, type: string, item: any) {
        if (!item?.id || this.isReadonlyItem(item) || this.editingId === type + ':' + item.id || this.movingItem) {
            event.preventDefault();
            return;
        }

        const payload = { type, id: item.id, name: item.name || '' };
        this.draggingItem = payload;
        if (event.dataTransfer) {
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData(this.driveDragMime, JSON.stringify(payload));
            event.dataTransfer.setData('text/plain', `${type}:${item.id}`);
        }
        this.service.render();
    }

    public onItemDragEnd(event: any) {
        this._clearDragState();
        this.service.render();
    }

    public onMoveTargetDragOver(event: any, folderId: string) {
        if (!this.canDropToFolderId(folderId)) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';

        const targetKey = this._targetKey(folderId);
        if (this.dragOverFolderId !== targetKey) {
            this.dragOverFolderId = targetKey;
            this.service.render();
        }
    }

    public onMoveTargetDragLeave(event: any, folderId: string) {
        const current = event.currentTarget;
        const next = event.relatedTarget;
        if (current && next && current.contains(next)) return;

        if (this.dragOverFolderId === this._targetKey(folderId)) {
            this.dragOverFolderId = '';
            this.service.render();
        }
    }

    public async onMoveTargetDrop(event: any, folderId: string) {
        const item = this._readDragItem(event);
        if (!item) return;

        event.preventDefault();
        event.stopPropagation();

        if (!this._canDropItemToFolder(item, folderId)) {
            this._clearDragState();
            await this.service.render();
            return;
        }

        if (!await this._ensureMetadataIdle()) {
            this._clearDragState();
            await this.service.render();
            return;
        }

        if (item.type === 'file' && !await this._allowMetadataDraftDiscard('파일 이동', '변경 취소하고 이동')) {
            this._clearDragState();
            await this.service.render();
            return;
        }

        this.movingItem = true;
        this.dragOverFolderId = '';
        await this.service.render();

        try {
            const res: any = await wiz.call('move_item', {
                item_type: item.type,
                item_id: item.id,
                target_folder_id: folderId || ''
            });

            if (res.code === 200) {
                await this.load();
            } else {
                await this.service.modal.show({
                    title: '이동 실패',
                    message: res.data?.message || '항목을 이동하지 못했습니다.',
                    action: '확인',
                    cancel: false,
                    status: 'error',
                });
            }
        } catch (e) {
            await this.service.modal.show({
                title: '이동 실패',
                message: this.getErrorMessage(e, '항목을 이동하지 못했습니다.'),
                action: '확인',
                cancel: false,
                status: 'error',
            });
        }

        this.movingItem = false;
        this._clearDragState();
        await this.service.render();
    }

    public async onDrop(event: any) {
        event.preventDefault();
        const draggedItem = this._readDragItem(event);
        if (draggedItem) {
            this._clearDragState();
            await this.service.render();
            return;
        }

        const dt = event.dataTransfer;
        if (!dt) return;
        if (this.isCurrentFolderReadonly) {
            await this._showDriveError('읽기 전용 폴더', 'M-Pro 공유 폴더에는 파일을 추가하거나 이동할 수 없습니다.');
            return;
        }
        if (!await this._allowMetadataDraftDiscard('파일 업로드', '변경 취소하고 업로드')) return;

        if (dt.items && dt.items.length > 0) {
            const entries: any[] = [];
            for (let i = 0; i < dt.items.length; i++) {
                const entry = dt.items[i].webkitGetAsEntry?.();
                if (entry) entries.push(entry);
            }
            if (entries.some((e: any) => e.isDirectory)) {
                await this._handleDirectoryDrop(entries);
                return;
            }
        }

        if (dt.files && dt.files.length > 0) {
            let uploaded = false;
            try {
                const totalSize = Array.from(dt.files as FileList).reduce((s: number, f: File) => s + f.size, 0);
                this.uploading = true;
                this.uploadPercent = 0;
                this.uploadProgress = `파일 ${dt.files.length}개 (${this.formatSize(totalSize)}) 업로드 준비 중...`;
                await this.service.render();

                await this._uploadFilesWithProgress(
                    Array.from(dt.files as FileList),
                    `파일 ${dt.files.length}개`,
                    this.currentFolder,
                    0,
                    totalSize,
                );
                uploaded = true;
            } catch (e) {
                this._resetUploadState();
                await this.service.render();
                await this._showDriveError('파일 업로드 실패', this.getErrorMessage(e, '파일 업로드에 실패했습니다.'));
            }

            this._resetUploadState();
            await this.load();

            if (uploaded && this.files.length > 0) {
                await this.generateMetadata(false);
            }
        }
    }

    private async _handleDirectoryDrop(entries: any[]) {
        this.uploading = true;
        this.uploadPercent = 0;
        this.uploadProgress = '드롭된 폴더 구조 분석 중...';
        await this.service.render();

        const fileEntries: { path: string; file: File }[] = [];
        const allFolderPaths: Set<string> = new Set();

        const readEntry = (entry: any, path: string): Promise<void> => {
            return new Promise((resolve) => {
                if (entry.isFile) {
                    entry.file((file: File) => { fileEntries.push({ path, file }); resolve(); });
                } else if (entry.isDirectory) {
                    allFolderPaths.add(path + entry.name);
                    const reader = entry.createReader();
                    reader.readEntries(async (children: any[]) => {
                        for (const child of children) await readEntry(child, path + entry.name + '/');
                        resolve();
                    });
                } else { resolve(); }
            });
        };

        for (const entry of entries) await readEntry(entry, '');

        if (fileEntries.length === 0) {
            this._resetUploadState();
            await this.service.render();
            return;
        }

        for (const fe of fileEntries) {
            const parts = fe.path.split('/').filter((p: string) => p);
            for (let j = 1; j <= parts.length; j++) allFolderPaths.add(parts.slice(0, j).join('/'));
        }

        const sortedPaths = Array.from(allFolderPaths).sort();
        const folderIdMap: Map<string, string> = new Map();
        folderIdMap.set('', this.currentFolder);
        const createdFolders: any[] = [];
        const uploadedFileIds: string[] = [];

        try {
            for (const path of sortedPaths) {
                const parts = path.split('/');
                const folderName = parts[parts.length - 1];
                const parentPath = parts.slice(0, -1).join('/');
                const parentId = folderIdMap.get(parentPath);
                if (typeof parentId === 'undefined') {
                    throw new Error(`${path} 생성 실패: 상위 폴더를 확인할 수 없습니다.`);
                }

                this.uploadProgress = `폴더 생성: ${path}`;
                await this.service.render();

                const res: any = await wiz.call("create_folder", { name: folderName, parent_id: parentId });
                if (res.code === 200 && res.data?.id) {
                    folderIdMap.set(path, res.data.id);
                    createdFolders.push({ id: res.data.id, path, name: folderName });
                } else {
                    throw new Error(`${path} 생성 실패: ${this.getResponseMessage(res, '폴더를 만들지 못했습니다.')}`);
                }
            }

            const pathFileMap: Map<string, File[]> = new Map();
            for (const fe of fileEntries) {
                const folderPath = fe.path.replace(/\/$/, '');
                if (!pathFileMap.has(folderPath)) pathFileMap.set(folderPath, []);
                pathFileMap.get(folderPath)!.push(fe.file);
            }

            const totalSize = fileEntries.reduce((s, fe) => s + fe.file.size, 0);
            let uploadedFiles = 0;
            let uploadedBytes = 0;
            let bestFolderId = '';
            let bestFileCount = 0;

            for (const [folderPath, files] of pathFileMap.entries()) {
                const targetFolderId = folderIdMap.get(folderPath);
                if (typeof targetFolderId === 'undefined') {
                    throw new Error(`${folderPath || '루트'} 업로드 실패: 대상 폴더를 확인할 수 없습니다.`);
                }
                const batchSize = files.reduce((s, f) => s + f.size, 0);

                if (files.length > bestFileCount) {
                    bestFileCount = files.length;
                    bestFolderId = targetFolderId;
                }

                const batchLabel = `${folderPath || '루트'} (${uploadedFiles}/${fileEntries.length} 파일, ${this.formatSize(uploadedBytes)} / ${this.formatSize(totalSize)})`;
                try {
                    const res = await this._uploadFilesWithProgress(
                        files,
                        batchLabel,
                        targetFolderId,
                        uploadedBytes,
                        totalSize,
                    );
                    uploadedFileIds.push(...this._uploadedIds(res));
                } catch (e) {
                    throw new Error(`${folderPath || '루트'} 업로드 실패: ${this.getErrorMessage(e, '파일 업로드에 실패했습니다.')}`);
                }
                uploadedFiles += files.length;
                uploadedBytes += batchSize;
            }

            this._resetUploadState();

            await this._finishFolderUpload(bestFolderId);
        } catch (e) {
            this.uploadProgress = '업로드 실패 항목 정리 중...';
            await this.service.render();
            const cleanupFailures = await this._rollbackCreatedUpload(createdFolders, uploadedFileIds);
            const cleanupMessage = this._cleanupMessage(createdFolders, uploadedFileIds, cleanupFailures);
            this._resetUploadState();
            await this.load();
            await this._showDriveError('폴더 업로드 실패', this.getErrorMessage(e, '폴더 업로드에 실패했습니다.') + cleanupMessage);
        }
    }

    public onDragOver(event: any) {
        event.preventDefault();
        if (event.dataTransfer) {
            event.dataTransfer.dropEffect = this.isCurrentFolderReadonly ? 'none' : (this.draggingItem ? 'move' : 'copy');
        }
    }
}

export default PageDriveComponent;